import HeaderMain from './HeaderMain.container'

export default HeaderMain
